import { Ehr } from '@patient/store/ehr/Ehr';
import { DateHelper } from '@utils/DateHelper';

import { CreateZebraSimpleLabelForm, LabelResponse } from 'chaika-frontend-types/frontend-cms/laboratory';

import { axios } from '@lib/axios';

const BASE_URL = 'http://localhost:5535';

export class ZebraApi {
    public static async print(label: string): Promise<void> {
        await axios.post(`${BASE_URL}/job`, { raw: label });
    }

    public static async generateSimpleLabel({
        lastName,
        firstName,
        patronymic,
        recordId,
        birthDate = '',
    }: Ehr): Promise<string> {
        const body: CreateZebraSimpleLabelForm = {
            patient: {
                lastName,
                firstName,
                patronymic,
                birthDate: birthDate.split('.').reverse().join('-'),
                cardNumber: recordId.toString(),
            },
            date: DateHelper.toIsoWithTimezone(new Date()),
        };
        const { data } = await axios.post<LabelResponse>('/api/printer/zebra/simple-label', body);

        return data.label;
    }
}
